import React, { useState } from 'react'
import ProcessLoader from './ProcessLoader';
import axios from 'axios';
import toast from 'react-hot-toast';

const ImportFile = ({ url, onSuccess }) => {

    const [disable, setDisable] = useState(false);

    const handleSubmit = (e) => {
        const file = e.target.files[0];
        if (!file) {
            toast.error('Please select a file.');
            return;
        }
        const fileType = file.type;
        if (fileType !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            toast.error('Only .xlsx files are allowed.');
            return;
        }
        setDisable(true);
        var bodyFormData = new FormData();
        bodyFormData.append("file", e?.target?.files[0]);
        bodyFormData.append("firm_id", localStorage.getItem('PAY_USER_FIRM_ID'));
        if (localStorage.getItem('PAY_USER_YEAR_ID') !== 'undefined') {
            bodyFormData.append("year_id", localStorage.getItem('PAY_USER_YEAR_ID'));
        }
        axios({
            method: "post",
            url: url,
            data: bodyFormData,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
        }).then((result) => {
            // console.log("=====", result);
            if (result.data.success === true) {
                toast.success(result?.data?.message);
                if (onSuccess) {
                    onSuccess();
                }
            } else {
                toast.error(result?.data?.message)
            }
            setDisable(false);
            // clear the file input
            e.target.value = '';
        }).catch((error) => {
            toast.error(error?.response?.data?.message);
            setDisable(false);
        })
    }


    return (
        <>
            <input
                type="file"
                onChange={handleSubmit}
                disabled={disable}
                style={{ display: 'none' }}
                id="fileInput"
            />
            <label
                className="btn btn-refresh"
                data-toggle="tooltip"
                data-placement="top"
                title="import"
                htmlFor="fileInput"
                disabled={disable}
            >
                {disable ? <ProcessLoader /> : <i className="fa-solid fa-upload"></i>}
            </label>
        </>
    )
}

export default ImportFile